var _style, _path, _path2, _rect, _path3, _path4, _circle, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHandMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    width: 36,
    height: 36,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#0E82FD;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3,25l2.6-4.2c1.5-2.3,4-3.8,6.8-3.8H19v0c0,2.2-1.8,4-4,4h-2",
    fill: "#0E82FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15,21h8l1.2-1.6c1.1-1.5,2.9-2.4,4.8-2.4h0l-2.7,4.8c-1.4,2.6-4.2,4.2-7.1,4.2h0c-4.7,0-9.3,1.4-13.2,4l0,0",
    fill: "#0E82FD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 2,
    className: "st0",
    width: 22,
    height: 12
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27,6c-2.2,0-4-1.8-4-4",
    fill: "#0E82FD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5,10c2.2,0,4,1.8,4,4",
    fill: "#0E82FD"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 16,
    cy: 8,
    r: 3,
    fill: "#0E82FD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9,2c0,2.2-1.8,4-4,4",
    fill: "#0E82FD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27,10c-2.2,0-4,1.8-4,4",
    fill: "#0E82FD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandMoney);
export default __webpack_public_path__ + "static/media/hand-money.fefb0efe1016e3b7485d3885185eb257.svg";
export { ForwardRef as ReactComponent };